
import React from "react";
import styles from "./Destinations1.module.css";

const fallbackImages = [
  "/assets/images/default-package.jpg",
  "/assets/images/default-package2.png",
  "/assets/images/default-package3.png",
  "/assets/images/default-package4.png",
  "/assets/images/default-package5.png",
  "/assets/images/default-package6.jpg"
];

const Destinations1 = ({ destinations = [] }) => {

  if (!destinations || destinations.length === 0) return null;

  const scrollItems = [...destinations, ...destinations];

  return (
    <section className={styles.section}>
      <div className="container text-center mb-5">
        <h2 className={styles.title}>Popular Destinations</h2>
        <p className={styles.lead}>Find your next dream vacation</p>
      </div>

      <div className={styles.track}>
        {scrollItems.map((dest, index) => {

          const fallbackImage =
            fallbackImages[index % fallbackImages.length];

          const imageUrl =
            dest?.image && dest.image.trim() !== ""
              ? dest.image
              : fallbackImage;

          return (
            <div key={index} className={styles.card}>
              <img
                src={imageUrl}
                alt={dest.name}
                className={styles.image}
                onError={(e) => {
                  e.target.src = fallbackImage;
                }}
              />

              <div className={styles.overlay}>
                <h3 className={styles.cardTitle}>{dest.name}</h3>
              </div>
            </div>
          );
        })}
      </div>
    </section>
  );
};

export default Destinations1;